module.exports = __webpack_public_path__ + "assets/calendar-check.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/calendar-check.svg
// module id = 1659
// module chunks = 7